// extracted by mini-css-extract-plugin
export default {"name":"Header_name__QzE4g","code":"Header_code__nUKqn","item":"Header_item__y6OOo"};